module.exports = __webpack_public_path__ + "static/img/GB-ENG.4628c885.svg";